import { createDocModalExecutor } from '@organisms/actions/createDocModalExecutor';
import { IVoteWithSignProps } from './IVoteWithSignProps';
import { VoteQuestionWithSignExecutorModal } from './VoteQuestionWithSignExecutorModal';

export const VoteQuestionWithSignExecutor = createDocModalExecutor<IVoteWithSignProps>({
    modal: VoteQuestionWithSignExecutorModal,
    defaultModalSize: 'xl',
    emptyElement: <div />,
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        docId: objId ?? '',
        action: action,
        userType: action.options?.userType ?? 'secretary',
        participantVote: action.options?.participantVote,
        okButtonText,
        cancelButtonText,
        modalSize,
        completeHandler,
    }),
});
